import { constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { programLanguageTypeDecoder } from '@/infrastructure/decoders/language/programLanguageTypeDecoder'

export const modelAnswerDecoder: Decoder<ModelAnswer> = object({
  codeSize: number(),
  cpuTime: number(),
  judgeId: number(),
  language: programLanguageTypeDecoder,
  memory: number(),
  policy: union(string(), constant(null)),
  problemId: string(),
  rating: number(),
  review: number(),
  server: number(),
  submissionDate: number().map(x => new Date(x)),
  userId: string(),
  version: string()
}).map(x => ({ ...x, programLanguage: x.language }))
